module.exports = __webpack_public_path__ + "static/media/Valckenier.b2bea17c.png";